import { useState, useEffect } from "react";
import { getAgreementGrantTokenEconomic } from "../../../../../apis/E-conomic/AgreementGrantTokenApi";
import { getEconomicSupplierData } from "../../../../../apis/E-conomic/SupplierDataApi";
import checklistSupplierIcon from "../../../../../assets/design-revamp-company/company-epr/epr-checklist.svg";
import closeBtn from "../../../../../assets/design-revamp-company/company-epr/x_btn_epr.svg";
import checklistBtn from "../../../../../assets/design-revamp-company/company-epr/checklist_btn.svg";
import connectIcon from "../../../../../assets/design-revamp-company/company-epr/connect_icon.svg";
import {
  getBusinessCentralCallback,
  getAdminConsentBusinessCentral,
} from "../../../../../apis/BusinessCentral/BusinessCentralConnectApi";
import { useTranslation } from "react-i18next";
export const supplierDataEvents = new EventTarget();

const WithButtonsBox = ({
  yearEcoApi,
  chosenYear,
  setIsFetchedSupplier,
  period,
  allocatedYear,
}) => {
  const [accounts, setAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const savedToken = localStorage.getItem("economic_token");
  const handleClick = () => {
    window.location.href =
      "https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=Arf5dBMxp7LnSd4M29eDjMEB63WmxllfzmJy6xxjqz8&redirectUrl=https%3A%2F%2Fyour-fair-share.com%2Fcompany";
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (code) {
      handleCallback(code);
    }
  }, []);

  const handleAuth = () => {
    getAdminConsentBusinessCentral();
    // getBusinessCentralAuth();
  };

  const handleCallback = (code) => {
    getBusinessCentralCallback(code).then(() => {
      window.history.replaceState({}, document.title, window.location.pathname);
    });
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (token) {
      getAgreementGrantTokenEconomic();
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (savedToken && chosenYear && period && allocatedYear) {
        setIsLoading(true);
        try {
          // Fetch supplier data
          const supplierData = await getEconomicSupplierData({
            setSuppliers: setAccounts,
            year: yearEcoApi,
            chosenYear: chosenYear,
            period: period,
            allocatedYear: allocatedYear,
          });

          if (isMounted) {
            setIsFetchedSupplier(true);
            setIsLoading(false);

            // Dispatch event when supplier data is ready
            const event = new CustomEvent("supplierDataReady", {
              detail: { supplierData },
            });
            supplierDataEvents.dispatchEvent(event);
          }
        } catch (error) {
          console.error("Error fetching supplier data:", error);
          if (isMounted) {
            setIsLoading(false);
          }
        }
      }
    };

    fetchData();

    // Cleanup function to prevent state updates on unmounted component
    return () => {
      isMounted = false;
    };
  }, [
    savedToken,
    yearEcoApi,
    chosenYear,
    setIsFetchedSupplier,
    period,
    allocatedYear,
  ]);

  useEffect(() => {
    if (accounts?.length > 0) {
      setIsFetchedSupplier(true);
    }
  }, [accounts?.length, setIsFetchedSupplier]);

  return (
    <div className="epr-paragraph-box">
      <p>
        {isLoading ? (
          "Loading accounts data..."
        ) : (
          <>
            Connected to your ERP system - we have loaded{" "}
            <span className="suppliers-check-epr">
              <span className="suppliers-amount-epr">
                {accounts?.length ?? 0}
              </span>
              <img
                src={checklistSupplierIcon}
                alt="Checklist Supplier Icon"
                width={18}
                height={18}
                style={{ padding: "0 5px" }}
              />
            </span>{" "}
            accounts.
          </>
        )}
      </p>
      <p style={{ textAlign: "center", fontWeight: "bold" }}>
        {" "}
        {t("CONNECT_ERP_SYSTEM")}
      </p>
      <p style={{ marginBottom: "10px" }}>{t("CONNECT_ERP_DESC_1")}</p>
      <p> {t("CONNECT_ERP_DESC_2")}.</p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* <div
          className="connect-btn-epr"
          style={{ marginRight: "10px" }}
          onClick={handleAuth}
        >
          <img
            src={closeBtn}
            alt="Close btn"
            width={20}
            height={20}
            style={{ position: "absolute", top: "-1px", left: "-3px" }}
          />
          <div className="connect-epr-api">
            <p>Connect to Business Central</p>
          </div>
          <div
            style={{
              padding: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={connectIcon}
              alt="Checklist Button"
              width={28}
              height={28}
            />
          </div>
        </div> */}

        <div className="connect-btn-epr" onClick={handleClick}>
          <img
            src={closeBtn}
            alt="Close btn"
            width={20}
            height={20}
            style={{ position: "absolute", top: "-1px", left: "-3px" }}
          />
          <div className="connect-epr-api">
            <p>
              {!savedToken ? "Connect to E-conomic" : "Connected to E-conomic"}
            </p>
          </div>
          <div
            style={{
              padding: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={!savedToken ? connectIcon : checklistBtn}
              alt="Connect Icon"
              width={!savedToken ? 28 : 40}
              height={!savedToken ? 28 : 40}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithButtonsBox;
